import { Plus } from 'lucide-react'

import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

import { PageHeader } from '@/components/atoms'
import { CarrierServices } from '@/components/shipping/CarrierServices'
import { ShippingMethods } from '@/components/shipping/ShippingMethods'
import { ShippingZones } from '@/components/shipping/ShippingZones'

import { useBusiness } from '@/contexts/BusinessContext'

export const ShippingDashboard = () => {
  const [activeTab, setActiveTab] = useState('zones')
  const { formatCurrency } = useBusiness()

  // Mock stats - replace with actual data
  const stats = {
    totalZones: 5,
    activeMethods: 12,
    averageShippingCost: 8.5,
    freeShippingOrders: 245,
  }

  return (
    <div className="space-y-4">
      <PageHeader
        size="large"
        title="Shipping and delivery"
        actions={
          <>
            {activeTab === 'zones' && (
              <Button>
                <Plus />
                Add zone
              </Button>
            )}
            {activeTab === 'methods' && (
              <Button>
                <Plus />
                Add method
              </Button>
            )}
            {activeTab === 'carriers' && (
              <Button>
                <Plus />
                Add carrier
              </Button>
            )}
          </>
        }
      />

      <Card className="overflow-hidden">
        <CardHeader className="pb-2">
          <CardTitle>Zones, methods and carriers</CardTitle>
          <CardDescription>
            {stats.totalZones} zones, {stats.activeMethods} active methods, average cost{' '}
            {formatCurrency(stats.averageShippingCost)}, {stats.freeShippingOrders.toLocaleString()} free shipping orders
          </CardDescription>
        </CardHeader>
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <div className="no-scrollbar overflow-x-auto px-2 pb-2">
            <TabsList>
              <TabsTrigger value="zones">Zones</TabsTrigger>
              <TabsTrigger value="methods">Methods</TabsTrigger>
              <TabsTrigger value="carriers">Carriers</TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value="zones" className="mt-0">
            <ShippingZones />
          </TabsContent>

          <TabsContent value="methods" className="mt-0">
            <ShippingMethods />
          </TabsContent>

          <TabsContent value="carriers" className="mt-0">
            <CarrierServices />
          </TabsContent>
        </Tabs>
      </Card>
    </div>
  )
}
